import rescue from './rescue';

export default (time, defaultValue = null) => {
  const value = parseFloat(time);

  if (value == time) return value;

  return rescue(() => (time.match(/[0-9]+s$/) ? value * 1000 : value), defaultValue);
}
